"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSavedQuoteBlock = void 0;
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var isSavedQuoteBlock = function (block) { return block.type === BlockTypes_1.BlockType.Quote; };
exports.isSavedQuoteBlock = isSavedQuoteBlock;
